export const INFO_POINTS_EDITION = {
    MAGAZINE: "The magazine inherits the name from the selected Edition Number.",
    PARENT_EDITION: "Select only if the edition is an attachment. Indicate the edition number to which this magazine is attached.",
    EDITION_NUMBER: "Enter the edition number. The magazine name will be derived from this field.",
    RELEVANT_PERIOD_START: "The relevant period of the magazine (start date).",
    RELEVANT_PERIOD_END: "The relevant period of the magazine (end date).",
    DESCRIPTION: "Additional information about the Magazine"
}

export const INFO_POINTS_ARTICLE = {
    THEME: "Select the topic presented in the article.",
    TITLE: "Insert the title of the article.",
    TAG: "Enter the relevant tags for the article. Press Enter after each tag to save.",
    DATE: "Insert the article date.",
    PUBLISHED: "By selecting this field, the article will be published online on Prima Archive.",
    SUBHEAD: "Insert the article subhead.",
    SUMMARY: "Insert the article summary.",
    SIGNATURE: "Insert here the writer’s name.",
    PAGE_FROM: "Enter the page number of the magazine where the article begins.",
    PAGE_TO: "Enter the page number of the magazine where the article ends.",
    TEXT: "Insert the article text."
}


// WEBPACK FOOTER //
// ./src/FileMaker/infoPointsConstants.js